/**
 * @param {url} - The current url
 * @returns current locale bind to request headers
 */
export function bindLocaleIntoHeaders(url) {
  return url.searchParams.append('locale', localStorage.getItem('locale') || 'en');
}
